export default __webpack_public_path__ + "translate-chrome-2.png";